module.exports = __webpack_public_path__ + "img/archive_yellow.cb983456.svg";